import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Page/page';
import { css } from '@patternfly/react-styles';
export var PageHeaderTools = function PageHeaderTools(_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  return React.createElement("div", Object.assign({
    className: css(styles.pageHeaderTools, className)
  }, props), children);
};